<template>
  <div class="flex flex-row gap-2">
    <i :class="iconClass"></i>
    <div class="flex flex-col gap-2 flex-1">
      <div class="flex flex-row justify-between">
        <span>{{ item.name }}</span>
        <el-button :type="levelButtonType" round size="small">
          {{ enumValueToLabel(EventLogLevel, item.level) }}
        </el-button>
      </div>
      <div v-if="item.assetName">
        <span>{{ item.assetName }}</span>
      </div>
      <div>
        <span
          v-if="item.status === EventLogStatus.OPEN"
          class="status-btn status-open"
        >
          Open
        </span>
        <span
          v-if="item.status === EventLogStatus.ACKNOWLEDGED"
          class="status-btn status-ack"
        >
          Acknowledged
        </span>
        <span
          v-else-if="item.status === EventLogStatus.RESOLVED"
          class="status-btn status-resolved"
        >
          Resolved
        </span>
      </div>
      <div>
        <span v-if="item.event" class="font-bold">Event:</span> {{ item.event }}
      </div>
      <div class="flex flex-row gap-2 items-center">
        <i class="el-icon-timer"></i>
        <span>{{ formatTime(item.timestamp) }}</span>
      </div>
      <div class="flex flex-row items-center gap-4">
        <el-tooltip content="Mark as True" placement="top">
          <i
            class="cursor-pointer fa fa-thumbs-up"
            :style="{
              color: item.aiAudit?.type === 'True' ? '#5fbf81' : '',
            }"
            @click="handleLike"
          ></i>
        </el-tooltip>
        <el-tooltip content="Mark as False" placement="top">
          <i
            class="cursor-pointer fa fa-thumbs-down"
            :style="{
              color: item.aiAudit?.type === 'False' ? '#ee4747' : '',
            }"
            @click="handleDislike"
          ></i>
        </el-tooltip>
        <el-button
          v-if="item.status !== EventLogStatus.RESOLVED"
          type="default"
          plain
          size="small"
          icon="el-icon-check"
          @click="handleResolve"
        >
          Resolve
        </el-button>
      </div>
      <!-- <template v-if="item.agentInfo">
        <el-tooltip
          class="item"
          effect="dark"
          :content="item.agentInfo?.reply"
          placement="left"
        >
          <div
            class="overflow-hidden text-gray-500"
            style="
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              max-height: 2.8em;
            "
          >
            <span class="font-bold text-gray-400">AI Analysis</span>:
            {{ item.agentInfo?.reply }}
          </div>
        </el-tooltip>
      </template> -->
    </div>
  </div>
</template>

<script>
import { EventLogLevel, EventLogStatus, enumValueToLabel } from "@/enums";
import { formatTime } from "@/utils/timeUtil";
import { MessageBox } from "element-ui";
import { updateDashboardEvent, createAiAudit, updateAiAudit } from "@/api";
import _ from "lodash";

export default {
  name: "EventLogItem",
  emits: ["update"],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    EventLogLevel: () => EventLogLevel,
    EventLogStatus: () => EventLogStatus,
    iconClass() {
      switch (this.item?.level) {
        case EventLogLevel.HIGH:
          return "fa fa-exclamation-triangle icon-size color-red";
        case EventLogLevel.MEDIUM:
          return "fa fa-globe icon-size color-orange";
        case EventLogLevel.LOW:
          return "el-icon-warning icon-size color-blue";
        default:
          return "el-icon-warning icon-size";
      }
    },
    levelButtonType() {
      switch (this.item?.level) {
        case EventLogLevel.HIGH:
          return "danger";
        case EventLogLevel.MEDIUM:
          return "default";
        case EventLogLevel.LOW:
          return "default";
        default:
          return "default";
      }
    },
  },
  methods: {
    enumValueToLabel,
    formatTime,
    async handleAcknowledge() {
      const payload = await this.$loaderWindow({
        title: "Add Tag",
        width: "426px",
        component: () => import("./AcknowledgeDialog.vue"),
        props: {
          id: this.item.id,
        },
      });
      const newItem = Object.assign({}, this.item);
      newItem.status = payload.status;
      newItem.tagInfo = payload.tagInfo;
      this.$emit("update", newItem);
    },
    async handleResolve() {
      await MessageBox.confirm("Are you sure you want to resolve this event?", {
        confirmButtonText: "Resolve",
        cancelButtonText: "Cancel",
        type: "warning",
      });

      await updateDashboardEvent({
        eventIds: [this.item.id],
        status: EventLogStatus.RESOLVED,
      });

      this.$emit("update", { ...this.item, status: EventLogStatus.RESOLVED });
    },
    async openChatDialog(resultObj) {
      const { agentId, conversationId } = resultObj;
      const name = "Event Agent";
      await this.$loaderWindow({
        title: `Chat with ${name}`,
        component: () => import("@/pages/ai-agent/components/ChatDialog.vue"),
        height: "80%",
        width: "70%",
        showHeader: false,
        padding: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        props: {
          agent: {
            agent_id: agentId,
            name,
          },
          conversationId: conversationId,
        },
      });
    },
    async submitAuditFeedback(type, feedback = "") {
      let audit = {
        eventId: this.item.id,
        agentId: this.item.agentInfo?.agentId || null,
        deviceKey: this.item.deviceKey || null,
        status: EventLogStatus.REVIEWED,
        type,
        feedback: feedback,
        userId: this.$store?.getters?.user?.id || "2",
      };
      try {
        //修改状态
        if (this.item.status === EventLogStatus.PENDING_FEEDBACK) {
          await updateDashboardEvent({
            eventIds: [this.item.id],
            status: EventLogStatus.REVIEWED,
          });
        }
        //提交审核反馈
        if (_.isNil(this.item.aiAudit)) {
          const { audit: entity } = await createAiAudit(audit);
          audit = entity;
        } else {
          audit.id = this.item.aiAudit.id;
          const { audit: entity } = await updateAiAudit(audit);
          audit = entity;
        }
        this.$message.success("Thank you for your feedback!");
        this.$emit("update", { ...this.item, aiAudit: audit });
      } catch (e) {
        this.$message.error("Failed to submit feedback");
      }
    },
    async handleLike() {
      await this.submitAuditFeedback("True");
    },
    async handleDislike() {
      const feedback = await this.$loaderWindow({
        title: "Feedback",
        width: "426px",
        component: () => import("./EditFeedbackDialog.vue"),
        props: {
          value: this.item.aiAudit?.feedback || "",
        },
      });
      await this.submitAuditFeedback("False", feedback);
    },
    async asyncItemDataFromListById() {},
  },
};
</script>

<style scoped>
.icon-size {
  font-size: 28px;
}

.color-red {
  color: #ee4747;
}

.color-orange {
  color: #f59e0b;
}

.color-blue {
  color: #84a9d5;
}

.color-green {
  color: #5fbf81;
}

.status-btn {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  border: 1px solid transparent;
  padding: 2px 10px;
  font-weight: 600;
  font-size: 10px;
  transition: background 0.2s, color 0.2s;
  outline: none;
  margin-right: 4px;
}

.status-open {
  color: #f87171;
  /* 红色 */
  border-color: #fca5a5;
  background: #fef2f2;
}

.status-ack {
  color: #fbbf24;
  /* 橙色 */
  border-color: #fde68a;
  background: #fffbeb;
}

.status-resolved {
  color: #34d399;
  /* 绿色 */
  border-color: #6ee7b7;
  background: #ecfdf5;
}
</style>
